import React, { useEffect, useRef, useState } from "react";
import { motion, useSpring, useTransform } from "framer-motion";
import { Users } from "lucide-react";
import { getLiveTraders } from "../../services/settings";

function AnimatedNumber({ value }) {
  const spring = useSpring(value, { stiffness: 90, damping: 18 });
  const [display, setDisplay] = useState(value);
  useEffect(() => { spring.set(value); }, [value, spring]);
  useEffect(() => spring.on("change", (v) => setDisplay(Math.round(v))), [spring]);
  return <span className="tabular-nums">{display.toLocaleString()}</span>;
}

export default function LiveTraders() {
  const [online, setOnline] = useState(0);
  useEffect(() => {
    const load = () => getLiveTraders().then((d) => setOnline(d.online)).catch(() => {});
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }}
      className="flex items-center gap-3 rounded-full border border-emerald-400/25 bg-emerald-400/[0.06] px-4 py-2"
      data-testid="live-traders"
    >
      <span className="relative flex h-2.5 w-2.5">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400/60" />
        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-emerald-400" />
      </span>
      <Users size={14} className="text-emerald-300/90" />
      <span className="font-mono text-[12px] tracking-wide text-white">
        <AnimatedNumber value={online} /> <span className="text-emerald-300/80">traders online</span>
      </span>
    </motion.div>
  );
}
